export default __webpack_public_path__ + "static/media/google-safebrowsing.7d2fc0cc.svg";